import { setUserInfo } from "../../utils/local-storage";
import { baseApi } from "./baseApi"

const AUTH_URL = '/auth'

export const authApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        userLogin: build.mutation({
            query: (loginData) => ({
                url: `${AUTH_URL}/login`,
                method: 'POST',
                data: loginData,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = (await queryFulfilled).data;
                    setUserInfo({ accessToken: result.accessToken });
                } catch (error) {
                }
            },
        }),
        patientSignUp: build.mutation({
            query: (data) => ({
                url: `/patient`,
                method: 'POST',
                data,
            }),
        }),
        doctorSignUp: build.mutation({
            query: (data) => ({
                url: `/doctor`,
                method: 'POST',
                data,
            }),
        }),
        resetPassword: build.mutation({
            query: (data) => ({
                url: `${AUTH_URL}/reset-password`,
                method: 'POST',
                data,
            }),
        }),
        resetConfirm: build.mutation({
            query: (data) => ({
                url: `${AUTH_URL}/reset-password/confirm`,
                method: 'POST',
                data,
            }),
        }),
        changePassword: build.mutation({
            query: (data) => ({
                url: `${AUTH_URL}/change-password`,
                method: 'POST',
                data,
            }),
        }),
        updateAdminProfile: build.mutation({
            query: (data) => ({
                url: `${AUTH_URL}/admin/profile`,
                method: 'PATCH',
                data,
            }),
        }),
    })
})

export const {
    useUserLoginMutation,
    useDoctorSignUpMutation,
    usePatientSignUpMutation,
    useResetPasswordMutation,
    useResetConfirmMutation,
    useChangePasswordMutation,
    useUpdateAdminProfileMutation
} = authApi